export default "./images/survio-3hk-l-reference-de.png";